//
import '../globals.js';

//
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import axios from '#/net/axios'
import touch from '#/directives/touch';
import lodash from 'lodash';
import srcConfig from "@/configs/index.js";
import payApi from "@/api/pay.js";
import cartApi from "@/api/cart.js";
import commonUtil from "@/utils/common";
import globalCommonUtil from "#/utils/common";

//
import constants from "@/constants.js"
import globalConstants from "#/utils/constants.js"

//
import echo_pb from '../../protocols_js/echo_pb';
import shop_pb from '../../protocols_js/shop_pb';
import address_pb from '../../protocols_js/address_pb';

//
import google_protobuf_any_pb from 'google-protobuf/google/protobuf/any_pb.js';

//
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
Vue.use(MuseUI);

//
import 'muse-ui-loading/dist/muse-ui-loading.css'; // load css
import Loading from 'muse-ui-loading';
Vue.use(Loading);

//
import Vant, { Toast, Dialog } from 'vant-ui';
Vue.use(Vant);

//
Vue.use(touch);

//
Vue.config.productionTip = false

// 加载全局组件
const requireComponent = require.context(
    // 其组件目录的相对路径
    '../../client_web_common/base_components',
    // 是否查询其子目录
    true,
    // 匹配基础组件文件名的正则表达式
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    // 获取组件的 PascalCase 命名
    const componentName = lodash.upperFirst(
        lodash.camelCase(
            // 获取和目录深度无关的文件名
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    //
    console.debug(`componentName: ${componentName}`);
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，
        // 否则回退到使用模块的根。
        componentConfig.default || componentConfig
    )
})

//
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    //
    next();
})

// 混入
Vue.mixin({
    data() {
        return {
            lodash,
            axios,
            Toast,
            Dialog,
            srcConfig,

            //
            echo_pb,
            shop_pb,
            address_pb,

            //
            ...constants,
            ...globalConstants,
            
            //
            google_protobuf_any_pb,
        }
    },

    methods: {
        ...commonUtil,
        ...globalCommonUtil,
        ...payApi,
        ...cartApi,
    }
});

//
Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
